const { indexBy, prop, pluck } = require('ramda')

const celebrationDateTypes = [
  { value: 'wedding-anniversary', label: 'Wedding Anniversary' },
  { value: 'work-anniversary', label: 'Work / Career Anniversary' },
  { value: 'other', label: 'Other' },
]

const celebrationDateTypeLabels = indexBy(prop('value'), celebrationDateTypes)
const celebrationDateTypeValues = pluck('value', celebrationDateTypes)

module.exports = { celebrationDateTypes, celebrationDateTypeLabels, celebrationDateTypeValues }
